import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "",
  style: {"overflow":"auto"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "plan-header" }
const _hoisted_4 = { class: "plan-currency" }
const _hoisted_5 = { class: "plan-type-row" }
const _hoisted_6 = { class: "plan-type-label" }
const _hoisted_7 = { class: "plan-type-badge" }
const _hoisted_8 = { class: "plan-type-row" }
const _hoisted_9 = { class: "plan-type-label" }
const _hoisted_10 = { class: "plan-type-badge" }
const _hoisted_11 = {
  key: 0,
  class: "plan-type-badge plan-type-badge--priority"
}
const _hoisted_12 = { class: "currency-code" }
const _hoisted_13 = {
  key: 0,
  class: "plan-limit"
}
const _hoisted_14 = { class: "plan-status" }
const _hoisted_15 = { class: "plan-details" }
const _hoisted_16 = {
  key: 0,
  class: "plan-progress"
}
const _hoisted_17 = { class: "progress-label" }
const _hoisted_18 = { class: "progress-bar" }
const _hoisted_19 = { class: "progress-text" }
const _hoisted_20 = {
  key: 1,
  class: "plan-deal-amount-range mt-2"
}
const _hoisted_21 = { class: "payment-options-label" }
const _hoisted_22 = {
  key: 2,
  class: "plan-payment-options"
}
const _hoisted_23 = { class: "payment-options-label" }
const _hoisted_24 = { class: "payment-options-list" }
const _hoisted_25 = {
  key: 3,
  class: "plan-timer"
}
const _hoisted_26 = { class: "timer-label" }
const _hoisted_27 = { class: "timer-value" }
const _hoisted_28 = {
  key: 1,
  class: "no-plans"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderContent = _resolveComponent("LoaderContent")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    class: "",
    title: _ctx.$t('limits.title'),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderContent, {
        ref: "loader",
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.plans && _ctx.plans.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plans, (plan) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: plan.settingId,
                      class: "plan-item mb-4"
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.helper.trans('limits.plan_type_label')) + ":", 1),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.helper.trans('limits.plan_type.' + (plan.planType || 'mandatory'))), 1)
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.helper.trans('limits.reward_type_label')) + ":", 1),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.helper.trans('limits.reward_type.' + (plan.rewardType || 'unlock_requisites'))), 1),
                            (plan.rewardType === 'priority_boost' && plan.rewardPriority)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.helper.trans('limits.reward_priority.' + plan.rewardPriority)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(plan.currency), 1),
                          (plan.limit)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.helper.trans('limits.limit')) + ": " + _toDisplayString(plan.limit), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["status-badge", {
                    'status-active': plan.isActive,
                    'status-inactive': !plan.isActive && !plan.isTimerActive,
                    'status-timer': !plan.isActive && plan.isTimerActive
                  }])
                          }, _toDisplayString(_ctx.getStatusText(plan)), 3)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        (plan.requiredDeals)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.helper.trans('limits.progress')) + ": " + _toDisplayString(plan.completedDeals) + " / " + _toDisplayString(plan.requiredDeals), 1),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", {
                                  class: "progress-fill",
                                  style: _normalizeStyle({ width: _ctx.getProgressPercent(plan) + '%' })
                                }, null, 4)
                              ]),
                              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.getProgressPercent(plan)) + "%", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.getDealAmountRangeText(plan))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.getDealAmountRangeText(plan)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (plan.allowedPaymentOptions && plan.allowedPaymentOptions.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.helper.trans('limits.allowed_payment_options')), 1),
                              _createElementVNode("div", _hoisted_24, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.allowedPaymentOptions, (option) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: option,
                                    class: "payment-option-badge"
                                  }, _toDisplayString(_ctx.helper.trans('payment_options.' + option)), 1))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (plan.isTimerActive && plan.timerExpiresAt && _ctx.isTimerActive(plan.timerExpiresAt))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.helper.trans('limits.timer')), 1),
                              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formatTimer(plan.timerExpiresAt)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.helper.trans('limits.no_plans')), 1)
                ]))
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}